export default {
    cms: {
        endpoint: 'https://cms.gladwellacademy.com/graphql'
    },
    api: {
        endpoint: 'https://api.gladwellacademy.com'
    }
};
